import { render, staticRenderFns } from "./wait-receiver-card.vue?vue&type=template&id=499757ac&scoped=true&"
import script from "./wait-receiver-card.vue?vue&type=script&lang=js&"
export * from "./wait-receiver-card.vue?vue&type=script&lang=js&"
import style0 from "./wait-receiver-card.vue?vue&type=style&index=0&id=499757ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499757ac",
  null
  
)

export default component.exports